import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';

export const namespace = 'ui';
const actionCreator = actionCreatorFactory(namespace);

export const SetIsLoading = actionCreator<{ isLoading: boolean }>(
  'SET_IS_LOADING'
);

export interface State {
  isLoading: boolean;
}

const initialState = (): State => {
  return { isLoading: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(SetIsLoading, function(context, action) {
      context.commit(SetIsLoading(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetIsLoading, (state, action) => {
      state.isLoading = action.payload.isLoading;
    })
  ),
  getters: {
    isLoading: state => state.isLoading,
  },
};
